import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./Redux/ConfigureStore";
import { Provider } from "react-redux";
import "@cdssnc/gcds-components-react/gcds.css";
import "@cdssnc/gcds-components";
import "@cdssnc/gcds-components-react";

import "@cdssnc/gcds-components-react/gcds.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
reportWebVitals();
